import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../shared/authentication.service';
import { Router, RouterModule } from '@angular/router';
import { MessageEvent, SignInEvent, LoaderEvent, HiddenFooter } from '../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import * as moment from 'moment';

import Staff from './signup.staff.model';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  providers: [AuthenticationService, MessageEvent, SignInEvent, RouterModule, LoaderEvent, AppService, HiddenFooter]
})
export class SignupComponent implements OnInit {
  private _router;
  private club;
  private superAdmin;
  private vendorAdmin;
  private staffs: Array<Staff>;
  private _appService;
  private contactNumbers;
  private emailIds;
  private popUpObject;
  private popUpMessage;
  public timezoneObj;
  public countryObj;
  public timezoneList;
  public countriesList;
  constructor(private router: Router, private authService: AuthenticationService, public privateviewContainerRef: ViewContainerRef,
    private messageEvent: MessageEvent, private signInEvent: SignInEvent, private loaderEvent: LoaderEvent, public appService: AppService,
    public hiddenFooter: HiddenFooter) {
    this._router = router;
    this.contactNumbers = {};
    this.emailIds = {};
    this.popUpMessage = '';
    this.superAdmin = {
      firstName: '',
      lastName: '',
      emailId: '',
      contactNumber: ''
    };
    this.club = {
      clubName: '',
      location: '',
      clubImageUrl: '',
      country:'',
      timezoneOffset:'',
      timezoneUTC:'',
      timezoneAbbr:'',
      isFeedbackEnabled:false
    };
    this.vendorAdmin = {
      firstName: '',
      lastName: '',
      emailId: '',
      contactNumber: ''
    };
    this.timezoneObj = '';
    this.countryObj = '';
    this.staffs = [];
    this._appService = appService;

    this._appService = appService;
        this._appService.getAppVersion().then((result: any) => {
             this.timezoneList = result.timezoneCountries;
             this.countriesList = result.timezoneCodes;
        });
  }

  ngOnInit() {
    this.emitTypeBroadcast();
  }

  showPopUp(message) {
    this.popUpMessage = message;
    this.popUpObject.showChildModal();
  }

  signUp(popUp) {
    this.popUpObject = popUp;
    this.contactNumbers = {};
    this.emailIds = {};
    if (this.validateData() && this.validateContactNumbers() && this.validateEmailIds()) {
      this.loaderEvent.fire(false);
      let vendorData = { superAdmin: this.superAdmin, club: this.club, vendorAdmin: this.vendorAdmin, staffs: this.staffs };
      this.authService.signUp(vendorData).then((result: any) => {
        this.loaderEvent.fire(true);
        if (result.status === 'SUCCESS') {
          this._router.navigate(['/']);
        } else {
          this.showPopUp(result.message);
        }
      });
    }
  }

  validateContactNumbers() {
    if (this.superAdmin.contactNumber.trim()) {
      this.contactNumbers[this.superAdmin.contactNumber] = true;
    } else {
      this.showPopUp('Enter a contact number for Super Admin.');
      return false;
    }

    if (this.vendorAdmin.contactNumber.trim()) {
      if (this.contactNumbers[this.vendorAdmin.contactNumber]) {
        this.showPopUp('Duplicate contact number for Vendor Admin.');
        return false;
      } else {
        this.contactNumbers[this.vendorAdmin.contactNumber] = true;
      }
    } else {
      this.showPopUp('Enter a contact number for Vendor Admin.');
      return false;
    }

    for (let _s in this.staffs) {
      let staff = this.staffs[_s];
      _s = (parseInt(_s) + 1).toString();
      if (staff.contactNumber.trim()) {
        if (this.contactNumbers[staff.contactNumber]) {
          this.showPopUp('Duplicate contact number for staff ' + _s);
          return false;
        } else {
          this.contactNumbers[staff.contactNumber] = true;
        }
      } else {
        this.showPopUp('Enter a contact number for staff ' + _s);
        return false;
      }
    }
    return true;
  }

  validateEmailIds() {
    if (this.superAdmin.emailId.trim()) {
      this.superAdmin.emailId = this.superAdmin.emailId.toLowerCase();
      if (this.validateEmailAddress(this.superAdmin.emailId)) {
        this.emailIds[this.superAdmin.emailId] = true;
      } else {
        this.showPopUp('Enter a valid email id for Super Admin.');
        return false;
      }
    } else {
      this.showPopUp('Enter an email id for Super Admin.');
      return false;
    }

    if (this.vendorAdmin.emailId.trim()) {
      this.vendorAdmin.emailId = this.vendorAdmin.emailId.toLowerCase();
      if (this.emailIds[this.vendorAdmin.emailId]) {
        this.showPopUp('Duplicate email id for Vendor Admin.');
        return false;
      } else {
        if (this.validateEmailAddress(this.vendorAdmin.emailId)) {
          this.emailIds[this.vendorAdmin.emailId] = true;
        } else {
          this.showPopUp('Enter a valid email id for Vendor Admin.');
          return false;
        }
      }
    } else {
      this.showPopUp('Enter an email id for Vendor Admin.');
      return false;
    }

    for (let _s in this.staffs) {
      let staff = this.staffs[_s];
      _s = (parseInt(_s) + 1).toString();
      if (staff.emailId.trim()) {
        staff.emailId = staff.emailId.toLowerCase();
        if (this.emailIds[staff.emailId]) {
          this.showPopUp('Duplicate Email id for staff ' + _s);
          return false;
        } else {
          if (this.validateEmailAddress(staff.emailId)) {
            this.emailIds[staff.emailId] = true;
          } else {
            this.showPopUp('Enter a valid email id for staff ' + _s);
            return false;
          }
        }
      } else {
        this.showPopUp('Enter an email id for staff ' + _s);
        return false;
      }
    }
    return true;
  }

  validateClub(club) {
    return (club.clubName.trim() && club.location.trim() && club.clubImageUrl.trim() && club.timezoneOffset && club.country);
  }

  validateEmailAddress(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  }

  validateData() {
    if (!this.validateClub(this.club)) {
      this.showPopUp('Enter correct Club details');
      return false;
    }

    if (!this.superAdmin.firstName.trim()) {
      this.showPopUp('Enter first name for Super Admin');
      return false;
    }

    if (!this.superAdmin.lastName.trim()) {
      this.showPopUp('Enter last name for Super Admin');
      return false;
    }

    if (!this.vendorAdmin.firstName.trim()) {
      this.showPopUp('Enter first name for Vendor Admin');
      return false;
    }

    if (!this.vendorAdmin.lastName.trim()) {
      this.showPopUp('Enter last name for Vendor Admin');
      return false;
    }

    for (let _s in this.staffs) {
      let staff = this.staffs[_s];
      _s = (parseInt(_s) + 1).toString();
      if (!staff.firstName.trim()) {
        this.showPopUp('Enter first name for staff ' + _s);
        return false;
      }

      if (!staff.lastName.trim()) {
        this.showPopUp('Enter last name for staff ' + _s);
        return false;
      }
    }
    return true;
  }

  AddStaff() {
    if (this.staffs.length <= 10) {
      this.staffs.push(new Staff());
    }
  }

  RemoveStaff(index) {
    if (this.staffs.length) {
      this.staffs.splice(index, 1);
    }
  }

  /**
   * function hide menu at sign in page by broadcaster
   */

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'none'
    };
    this.signInEvent.fire('none');
    this.hiddenFooter.fire(isShow);
  }

  timezoneChange(timezone){
    this.club.timezoneOffset = timezone.offset * - 60;
    this.club.timezoneUTC = timezone.utc[0];
    this.club.timezoneAbbr = timezone.abbr;
  }

  countryChange(country){
    this.club.country = country.name;

  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/signup/signup.component.ts